import {AbstractStorageModule} from "@/services/storage/AbstractStorageModule";
import {getCookie, waitFor} from "@/helpers";
import {app} from "@/app";

export type ContextRecord = {
  uri ?: null | string,
  url ?: null | {
    path ?: null | string,
    query ?: null | Record<any, any>,
  },
  params: Record<string, any>,
}

export class Context extends AbstractStorageModule {
  record: ContextRecord | null = null;

  async collect() {
    this.record = null;

    const queryParams = this.collectParamsFromQuery();
    const cookieParams = await this.collectParamsFromCookies(queryParams);

    this.record = {
      url: {
        path: window.location.protocol + "//" + window.location.host + window.location.pathname,
        query: queryParams,
      },
      uri: window.location.href,
      params: {
        ...cookieParams,
      }
    };
  }

  collectParamsFromQuery(): Record<string, any> {
    const result = {};
    (new URLSearchParams(decodeURIComponent(window.location.search).replaceAll('?', ''))).forEach((value, key) => {
      result[key] = value;
    });
    this.cleanupParams(result);
    return result;
  }

  async collectParamsFromCookies(queryParams: Record<string, any>): Promise<Record<any, any>> {
    const result: Record<string, any> = {};

    if(app.isSandboxed) return result;

    /* fbc */
    result.fbc = getCookie('_fbc');
    // wait for cookies
    if (!result.fbc) {
      app.debug('Pixel ContextRecord: collectParamsFromCookies: fbc is missing, waiting');

      await waitFor(() => {
        result.fbc = getCookie('_fbc');
        return (result.fbc != null);
      }, 500, false)
      .then(delay => {
        app.debug('Pixel ContextRecord: collectParamsFromCookies: fbc updated successfully', delay);
      })
      .catch((delay) => {
        app.debug('Pixel ContextRecord: collectParamsFromCookies: waited for fbc update unsuccessfully', delay, 'warn');
      });
    }
    await this.validateParamsFbc(result, queryParams);

    /* fbp */
    result.fbp = getCookie('_fbp');


    // parse utm params from cookie
    const rawUtmParams = getCookie('_shopify_sa_p');
    if (rawUtmParams) {
      (new URLSearchParams(decodeURIComponent(rawUtmParams)))
      .forEach((value, key) => {
        result[key] = value;
      });
    }


    this.cleanupParams(result);

    return result;
  }



  cleanupParams(params: any) {
    // remove empty params
    Object.entries(params).forEach(([key, value]) => {
      if (value && value != '') return;
      delete params[key];
    });
  }


  async validateParamsFbc(params: any, queryParams: Record<string, any>) {
    // wait for fbc cookie to update if fbclid not in fbc
    if (
      !params?.fbc ||
      !queryParams?.fbclid ||
      !params.fbc.includes(queryParams.fbclid)
    ) {
      return;
    }

    app.debug('Pixel ContextRecord: validateParamsFbc: fbclid is not a part of fbc, waiting for cookie to update', {
      fbc: params.fbc,
      fbclid: queryParams.fbclid
    });

    await waitFor(() => {
      params.fbc = getCookie('_fbc');
      return params.fbc.includes(queryParams.fbclid);
    }, 500, false)
    .then(delay => {
      app.debug('Pixel ContextRecord: validateParamsFbc: fbc updated successfully', delay);
    })
    .catch((delay) => {
      app.debug('Pixel ContextRecord: validateParamsFbc: waited for fbc update unsuccessfully', {
        delay,
        params
      }, 'warn');
    });
  }
}
